import { render, staticRenderFns } from "./CategoryPointProgressBar.vue?vue&type=template&id=6c38fcac&scoped=true&"
import script from "./CategoryPointProgressBar.vue?vue&type=script&lang=js&"
export * from "./CategoryPointProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPointProgressBar.vue?vue&type=style&index=0&id=6c38fcac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c38fcac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
